// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3UrN6","title":"InfoRow_title__3Pyuz"};